import _implicitStylesheets from "./markdown.css";
import _implicitScopedStylesheets from "./markdown.scoped.css?scoped=true";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = {
  "container": true
};
const stc1 = {
  "type-style": "body-2"
};
const stc2 = {
  lwc: {
    dom: "manual"
  }
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, h: api_element} = $api;
  const {_m0} = $ctx;
  return [api_element("div", {
    classMap: stc0,
    attrs: stc1,
    context: stc2,
    key: 0,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.handleContainerClick))
    }
  })];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-7sa4pmr5de4";
tmpl.legacyStylesheetToken = "undefined-_markdown";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
